module.exports = __webpack_public_path__ + "media/images/grapes-35b28f74d1742dbeb34be92367e61852.JPG";